var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4302 7.32115H3.98194L10.2355 1.89258C10.3355 1.80508 10.2748 1.64258 10.1427 1.64258H8.5623C8.49266 1.64258 8.42659 1.66758 8.3748 1.71222L1.62659 7.56758C1.56478 7.62115 1.51521 7.68739 1.48124 7.76179C1.44727 7.8362 1.42969 7.91704 1.42969 7.99883C1.42969 8.08062 1.44727 8.16146 1.48124 8.23587C1.51521 8.31027 1.56478 8.3765 1.62659 8.43008L8.41409 14.3212C8.44087 14.3444 8.47301 14.3569 8.50694 14.3569H10.1409C10.273 14.3569 10.3337 14.1926 10.2337 14.1069L3.98194 8.67829H14.4302C14.5087 8.67829 14.573 8.61401 14.573 8.53544V7.46401C14.573 7.38544 14.5087 7.32115 14.4302 7.32115Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.97c04f59080b3acfbf2fce40973f529d.svg";
export { ForwardRef as ReactComponent };